import { useEffect } from 'react';

export const SEO = ({ title, description, url, schema, faqs }) => {
  useEffect(() => {
    // 1. Update Document Title
    document.title = title;

    // Helper to set meta tags
    const setMeta = (name, content, attribute = 'name') => {
      let el = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attribute, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // 2. Standard Meta Tags
    setMeta('description', description);
    
    // 3. Open Graph Tags
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:url', url, 'property');
    setMeta('og:type', 'website', 'property');
    
    // 4. Twitter Card Tags
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    // 5. Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    // 6. JSON-LD Structured Data
    let script = document.querySelector('#seo-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'seo-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    const schemas = [];
    
    // Add primary schema (WebApplication, etc.)
    if (schema) {
      schemas.push(schema);
    }

    // Add FAQPage schema if FAQs exist
    if (faqs && faqs.length > 0) {
      schemas.push({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(faq => ({
          "@type": "Question",
          "name": faq.q,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.a
          }
        }))
      });
    }

    if (schemas.length > 0) {
      // If multiple schemas, wrap in an array (Google supports this)
      script.textContent = JSON.stringify(schemas.length === 1 ? schemas[0] : schemas);
    } else {
      script.textContent = '';
    }

  }, [title, description, url, schema, faqs]);

  return null;
};